import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'

import { getAuthMeeting, V1_MEETING_QUERY_KEY } from '@/features/meetings/api'

function useMeeting(meetingRoomIdRef: ComputedRef<string | null | undefined>) {
  const isMeetingRoomIdDefinedRef = computed(() => !!meetingRoomIdRef.value)

  const { data, isPending } = useQuery({
    queryKey: [V1_MEETING_QUERY_KEY, meetingRoomIdRef],
    queryFn: () => getAuthMeeting({ meetingRoomId: meetingRoomIdRef.value! }),
    enabled: isMeetingRoomIdDefinedRef,
  })

  return {
    roomUrlRef: computed(() => data?.value?.roomUrl),
    displayNameRef: computed(() => data?.value?.displayName),
    isPendingRef: isPending,
  }
}

export default useMeeting
